import { createContext, useContext, type ReactNode } from 'react';

const FilterScopeContext = createContext<string | null>(null);

/**
 * `filterListAtom` 의 스코프를 좁힌다. 미지정이면 `instanceId`(= 화면 단위)로 동작한다.
 *
 * 홈 탭들은 react-navigation route 를 공유하는 TabView 씬이라 `instanceId` 가 전부 같다.
 * 그래서 탭마다 이 provider 로 서로 다른 값을 주어 필터 상태를 격리한다.
 *
 * `instanceId` 를 탭별로 바꾸지 않는 이유: 그 값은 **네이티브 surface 식별자**로,
 * App 루트에서 네이티브가 넘긴 값이 주입되고(`InstanceIdProvider value={props.instanceId}`)
 * `foregroundAtom` / `focusedTabAtom` / `useNativeEvent` / `bridge.setScreenName` 등이
 * 그 값으로 네이티브와 매칭한다. 탭 이름으로 덮으면 그 lookup 들이 조용히 폴백한다.
 *
 * ⚠️ 필터 바텀시트는 `ModalProvider` 아래(탭 트리 **밖**)에서 렌더되어 이 컨텍스트가 닿지
 * 않는다. 시트를 열 때 현재 스코프를 param 으로 넘기고, 시트 내부에서 다시 이 provider 로
 * 씌워야 올바른 슬롯에 쓴다. (`useFilterBottomSheet` 의 `filterScope` 참고)
 */
export const FilterScopeProvider = ({
  scope,
  children,
}: {
  scope: string;
  children: ReactNode;
}) => (
  <FilterScopeContext.Provider value={scope}>
    {children}
  </FilterScopeContext.Provider>
);

/** 지정된 필터 스코프. 없으면 null → 호출부가 `instanceId` 로 폴백한다. */
export const useFilterScope = (): string | null =>
  useContext(FilterScopeContext);
